let host_url = 'http://localhost:5000/';
console.log(process.env.NODE_ENV)
// if(process.env.NODE_ENV=="production"){
    host_url = 'https://aulart-linktree-server-djmjefmz2a-ue.a.run.app/';
// }
 
export const HOST_URL = host_url;